<template>
  <div class="trade-record-item-info">
    <div class="recrd-title">
        {{ safeItem.ordertype_text }} &nbsp;
        <span :class="safeItem.type == 1? 'recrd-option-buy': 'recrd-option-sell'">{{ safeItem.type_text }}</span>
        <span class="recrd-type">{{ safeItem.coinname }}/{{ item.trade_coin }}</span>
        <span class="recrd-time">{{ safeItem.tradetime }}</span>
        <span style="float: right;" :class="safeItem.status == 2 ? 'data-up':'data-down' ">{{ safeItem.status == 2 ?  $t('tradelst.tab2'): safeItem.status == 3 ?  $t('tradelst.tab3'): safeItem.status }}</span>
    </div>
    <van-row>
        <van-col :span="9">
            <p>{{ $t('trade.price') }}({{ item.trade_coin }})</p>
            <span class="num">{{ safeItem.price }}</span>
        </van-col>
        <van-col :span="8">
            <p>{{ $t('trade.num') }}({{ item.coinname }})</p>
            <span class="num">{{ safeItem.predict_num }}</span>
        </van-col>
        <van-col :span="6" class="txt-right">
            <p>{{ $t('trade.clinch') }}({{ item.coinname }})</p>
            <span class="num">{{ safeItem.coinnum }}</span>
        </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'TradeViewItem',
  props: ['item'],
  computed: {
    safeItem(){
      return this.item || {}
    }
  },
  watch:{
    item(){}
  },
}
</script>

<style>

</style>
